import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { CusAddressInfo } from '../../customers/address.model';
import { BrandsInfo } from '../brands.model';
import { CurrencyDto } from '@gtpl/shared-models/masters';
import { CurrenciesDTO } from '../../currencies/dto/currencies.dto';
export class EndCustomersDTO {
  @ApiProperty()
  @IsNotEmpty({message:"End Customer id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  endCustomerId: number;
 
  @ApiProperty()
  @MaxLength(30, { message: "End Customer Code allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"End Customer Code should be only alpha numeric" })
  endCustomerCode: string;

  @ApiProperty()
  @MaxLength(30, { message: "End Customer Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"End Customer Name should be only alpha numeric" })
  endCustomerName: string;
  
  @ApiProperty()
  @MaxLength(30, { message: "currency allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"currency should be only alpha numeric" })
  currencyId: number;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty({ type: [CusAddressInfo]})
  addressInfo: CusAddressInfo[];
  @ApiProperty({ type: [BrandsInfo]})
  brandsInfo: BrandsInfo[];
  @ApiProperty({ type: [CurrenciesDTO]})
  currenciesInfo: CurrenciesDTO;

  @ApiProperty()
  filePath: string;
  @ApiProperty()
  fileName: string;

  @ApiProperty()
  @MaxLength(30, { message: "Consignee Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z\\s]+$"),{ message:"Consignee Name should be only alpha numeric" })
  consignee?: string;

}

